import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: `
      md:max-w-96
      flex
      h-24
      w-full
      justify-center
      pl-4
      lg:w-96
    `,
    image: `
      flex
      h-16
      w-16
      items-center
      justify-center
      rounded
    `,
  },
  variants: {
    variant: {
      default: {
        image: `
          border
          border-gray-200
        `,
      },
      green: {
        image: `
          bg-green-200
        `,
      },
    },
  },
});
